export const isNumeric = (n: any) => {
  return !isNaN(parseFloat(n)) && isFinite(n);
};

export const isString = (s: any) => {
  return typeof s === 'string' || s instanceof String;
};
